import { CardType } from '@/types/page'

import requestService from './request.service'

let cardCache: Record<string, CardType> = {}

const getCardMap = async (names: string[]): Promise<Record<string, CardType>> => {
  let cards: Record<string, CardType> = {}
  const remainingCardNames: string[] = []

  for (const name of names) {
    if (!name) {
      const e = new Error()
      console.log('Invalid card name:', name, e.stack)
      continue
    }
    if (cardCache[name]) cards[name] = cardCache[name]
    else remainingCardNames.push(name)
  }

  if (remainingCardNames.length > 1) {
    const chunkSize = 100
    for (let i = 0; i < remainingCardNames.length; i += chunkSize) {
      const chunk = remainingCardNames.slice(i, i + chunkSize)
      const fetchedCards = (
        await (
          await requestService.post(
            '/api/cards/',
            {
              format: 'dict',
              names: chunk,
            },
            {},
            true,
          )
        ).json()
      ).cards
      cards = { ...cards, ...fetchedCards }
    }
  } else if (remainingCardNames.length === 1) {
    cards[remainingCardNames[0]] = await (
      await requestService.get(`${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/cards/${remainingCardNames[0]}`, {}, true)
    ).json()
  }

  cardCache = { ...cardCache, ...cards }

  return cards
}

const getCard = async (name: string): Promise<CardType> => {
  const map = await getCardMap([name])
  return map[name]
}

const updateCardCache = (newCache: Record<string, CardType>) => {
  cardCache = { ...cardCache, ...newCache }
}

const cardService = { getCardMap, getCard, updateCardCache }

export default cardService
